import { JSONSchema7 } from 'json-schema';

const PayloadCarrierCountSimpleTextSchema = async () => {
    let schema: JSONSchema7 = {
        title: 'PayloadCarrierCountSimpleTextSchema',
        type: 'object',
        //
        definitions: {},
    };
    //
    schema = {
        properties: {
            className: {
                type: 'string',
            },
        },
        //
        ...schema,
    };
    //
    return schema;
};

export default PayloadCarrierCountSimpleTextSchema;
